import type { FooterColumn, NavItem, SocialLink } from '@/types/navigation';

export const headerNavItems: NavItem[] = [
  { label: 'WHY RAYS SPORTS', href: '#about' },
  { label: 'SOLUTIONS', href: '#services' },
  { label: 'SPORTS', href: '#sports' },
  { label: 'RAYSEYE', href: '#rayseye', isSpecial: true },
  { label: 'RESOURCES', href: '#resources' },
  { label: 'CONTACT', href: '#contact' },
  { label: 'REQUEST A DEMO', href: '#demo' },
];

const solutionLinks = [
  { label: 'Personalized Coaching', href: '#services' },
  { label: 'Live Remote Coaching', href: '#services' },
  { label: 'Structured Courses', href: '#services' },
  { label: 'Daily Fitness Mgmt Tool', href: '#services' },
  { label: 'Integrated Scoring Application', href: '#services' },
  { label: 'Payment Collection & Invoicing', href: '#services' },
  { label: 'User Access & Coach Schedule Management', href: '#services' },
  { label: 'Daily Practice Task Management', href: '#services' },
  { label: 'Club7MS – Club Management System', href: '#services' },
  { label: 'Audio video annotation tool "RaysEye"', href: '#rayseye' },
];

const solutionsMidpoint = Math.ceil(solutionLinks.length / 2);

export const footerColumns: FooterColumn[] = [
  {
    id: 'why',
    title: 'WHY RAYS SPORTS',
    links: [
      { label: 'Origin Story', href: '#about' },
      { label: 'Impact So Far', href: '#about' },
    ],
  },
  {
    id: 'solutions-1',
    title: 'SOLUTIONS',
    links: solutionLinks.slice(0, solutionsMidpoint),
  },
  {
    id: 'solutions-2',
    title: 'SOLUTIONS',
    links: solutionLinks.slice(solutionsMidpoint),
    hideTitle: true,
  },
  {
    id: 'sports',
    title: 'SPORTS',
    links: [
      { label: 'Cricket', href: '#sports' },
      { label: 'Basketball', href: '#sports' },
      { label: 'Football', href: '#sports' },
      { label: 'Badminton', href: '#sports' },
      { label: 'Tennis', href: '#sports' },
      { label: 'Baseball', href: '#sports' },
      { label: 'Volleyball', href: '#sports' },
    ],
  },
  {
    id: 'rayseye',
    title: 'RAYSEYE',
    isSpecial: true,
    links: [
      { label: 'Audio & Video Annotation', href: '#rayseye' },
      { label: 'Video Conferencing', href: '#rayseye' },
      { label: 'Athlete Monitoring', href: '#rayseye' },
    ],
  },
  {
    id: 'resources',
    title: 'RESOURCES',
    links: [
      { label: 'Case Studies', href: '#resources' },
      { label: 'Articles', href: '#resources' },
    ],
  },
  {
    id: 'contact',
    title: 'CONTACT',
    links: [
      { label: 'Send us a Message', href: '#contact' },
      { label: 'Careers', href: '#contact' },
      { label: 'Locations', href: '#contact' },
    ],
  },
];

export const socialLinks: SocialLink[] = [
  { icon: 'twitter', href: '#', label: 'Twitter' },
  { icon: 'instagram', href: 'https://www.instagram.com/rayssportsinc/', label: 'Instagram' },
  { icon: 'linkedin', href: 'https://www.linkedin.com/company/rays-sports-network-inc', label: 'LinkedIn' },
  { icon: 'youtube', href: '#', label: 'YouTube' },
  { icon: 'facebook', href: 'https://www.facebook.com/profile.php?id=61555327965848', label: 'Facebook' },
];
